export enum AuthorityArea {
  REGISTER_AREA_REPORTS = '1.13.5',
  REGISTER_AREA_EDIT = '1.13.4',
  REGISTER_AREA_DELETE = '1.13.3',
  REGISTER_AREA_ADD = '1.13.2',
  REGISTER_AREA_VIEW = '1.13.1',
  REGISTER_AREA_REGISTRATION = '1.13',

  REGISTER_SUBAREA_REPORTS = '1.14.5',
  REGISTER_SUBAREA_EDIT = '1.14.4',
  REGISTER_SUBAREA_DELETE = '1.14.3',
  REGISTER_SUBAREA_ADD = '1.14.2',
  REGISTER_SUBAREA_VIEW = '1.14.1',
  REGISTER_SUBAREA_REGISTRATION = '1.14',
}
